




































import Vue from 'vue';
import _ from 'lodash';
import { MedicaoPressaoArterial } from '../../../../back/src/entity/MedicaoPressaoArterial';

import { momentosMedicoesPressaoItems } from '../../utils/constants';

export default Vue.extend({
  name: 'MedicaoPressaoArterialDatatable',
  props: {
    medicoesPressaoArterial: {
      type: Array as () => MedicaoPressaoArterial[],
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,

    };
  },
  computed: {
    headersPeriodosPostura() {
      const headerItems: any[] = [];
      momentosMedicoesPressaoItems.forEach((el) => {
        headerItems.push({
          value: el.value,
          text: el.text,
          class: 'text-no-wrap',
          align: 'center',
          sortable: false,
          width: '14.2%',
          slotName: `item.${el.value}`,
        } as any);
      });
      return headerItems;
    },
    headers() {
      const headers: any[] = [
        {
          value: 'data_medicao',
          text: 'Data da medição',
          class: 'text-no-wrap',
          sortable: true,
          width: '14.2%',
          align: 'center',
        },
        ...this.headersPeriodosPostura,
      ];
      return headers;
    },
    medicoesPressaoArterialItens() {
      if (this.medicoesPressaoArterial.length === 0) {
        return [];
      }
      const arrItens: any[] = [];
      // ordena medicoes por data
      this.medicoesPressaoArterial.forEach((medicao: MedicaoPressaoArterial) => {
        const periodoPostura = `${medicao.periodo}${medicao.postura}`;
        // procura o item do array com a data
        const item: any = _.find(arrItens, (el: any) => el.data_medicao === medicao.data_medicao);
        if (!item) {
          // caso nao exista, cria, coloca o valor do momento registrado na medicao e poe no array
          const novoItem = {
            data_medicao: medicao.data_medicao,
          };
          novoItem[periodoPostura] = [medicao];
          arrItens.push(novoItem);
        } else if (item[periodoPostura]) {
          // caso ja exista alguma medicao naquele momento, adiciona outra
          item[periodoPostura].push(medicao);
        } else {
          // caso seja a primeira medicao daquele momento, cria o array com o valor dentro
          item[periodoPostura] = [medicao];
        }
      });
      return arrItens;
    },
  },
  methods: {
    medidaColor(medicao: MedicaoPressaoArterial) {
      if (medicao.max >= 140 || medicao.min >= 90) return 'coletivo_nascer';
      return 'grey';
    },
    tableDivClass(header: string, medicao) {
      const baseClass: string = 'subtitle-1 d-flex align-center justify-center my-1 divMedicao';
      const paddingX: string = this.$vuetify.breakpoint.xsOnly ? 'px-2' : '';
      let color: string = this.medidaColor(medicao);
      if (color === 'grey') color = 'grey lighten-2 grey--text text--darken-3';
      else color = `${color} lighten-3 ${color}--text text--darken-3`;
      return `${color} ${baseClass} ${paddingX}`;
    },
  },
});
